import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useUser from '../../hooks/useUser';
import CEOCategoryWiseReports from './ceo/CategoryWiseReports';
import AdminCategoryWiseReports from './admin/CategoryWiseReports';
import ManagerCategoryWiseReports from './manager/CategoryWiseReports';
import { clearErrors } from '../../store/slices/categoryWiseReportsSlice';
import { clearError as clearSalesError } from '../../store/slices/salesReportsSlice';

const CategoryWiseReports = () => {
    const dispatch = useDispatch();
    const { userRole } = useUser();

    useEffect(() => {
        dispatch(clearErrors());
        dispatch(clearSalesError());
    }, [dispatch]);

    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    if (roleLower === 'ceo') {
        return <CEOCategoryWiseReports />;
    } else if (roleLower === 'admin') {
        return <AdminCategoryWiseReports />;
    } else if (roleLower === 'manager') {
        return <ManagerCategoryWiseReports />;
    } else {
        return <ManagerCategoryWiseReports />;
    }
};

export default CategoryWiseReports;

